import { mapGetters } from 'vuex'
import {
  ValidationMixins,
  Validators,
  setValidationRule,
  parseValidationSetup,
  parseValidations,
  truthyRule,
} from '../../../../lib/validations'
const {required, helpers} = Validators

const EventBus = window.VueEventBus

const validations = {
  productId: setValidationRule('fields.productId'),
  termsAgreed: setValidationRule('fields.termsAgreed', {
    truthy: {error: 'Please agree to the Terms & Conditions', rule: truthyRule},
  }),

}

export default {
  name: 're-buy-card',
  props: {
    token: {},
    item: {},
    termsAgreed: {},
    editMode: {
      type: Boolean,
      default: false
    },
    editModeData: {
      type: Object,
      default: null
    },

    title: {
      type: String,
      default: 'Buy card'
    },
    showTitle: {
      type: [Boolean, Number, String],
      default: true
    },
    subTitle: {
      type: String,
      default: null,
    },
    showSubTitle: {
      type: [Boolean, Number, String],
      default: false
    },
    notice: {
      type: String,
      default: null
    },
    showNotice: {
      type: [Boolean, Number, String],
      default: false
    },
    showFormLabels: {
      type: [Boolean, Number, String],
      default: true,
    },
    hasPreviewCard: {
      type: Boolean,
      default: false,
    },
    previewButtonTitle: {
      type: String,
      default: 'Next',
    },
    previewCardBoxTitle: {
      type: String,
      default: 'Preview: The card email will look like this'
    },
    previewEditButtonTitle: {
      type: String,
      default: 'Edit'
    },
    previewCardBoxHtml: {
      default: null,
    },

    noAgreeToTerms: {
      type: Boolean,
      default: false
    },
    showGroupBoxTitle: {
      type: Boolean,
      default: true
    },
    groupBoxTitle: {
      type: String,
      default: 'Select your amount'
    },
    showProductSelector: {
      type: Boolean,
      default: true
    },
    productLabelFormat: {
      type: [String, Array, Object],
      default: null
    },
    amountClass: {
      type: [String, Array, Object],
      default: null
    },
    showAmountTitle: {
      type: Boolean,
      default: false
    },
    amountTitle: {
      type: String,
      default: 'Select your amount'
    },
    showAmountSubtitle: {
      type: Boolean,
      default: false
    },
    amountSubtitle: {
      type: String,
      default: 'Please choose the gift card amount.'
    },
    amountBoxLabel: {
      type: String,
      default: 'Amount'
    },
    amountSelectDefault: {
      type: String,
      default: 'Select a Card'
    },
    quantityClass: {
      type: [String, Array, Object],
      default: null
    },
    showQuantityTitle: {
      type: Boolean,
      default: false
    },
    quantityTitle: {
      type: String,
      default: 'Select quantity'
    },
    showQuantitySubtitle: {
      type: Boolean,
      default: false
    },
    quantitySubtitle: {
      type: String,
      default: 'Select quantity'
    },
    cardsList: {
      type: [Array, Object],
      default: null,
    },
    noQuantity: {
      type: Boolean,
      default: false
    },
    quantityLabel: {
      type: String,
      default: 'Quantity'
    },

    submitButtonTitle: {
      type: String,
      default: 'Add to Card'
    },
    submitButtonClasses: {
      type: [String, Array, Object],
      default: null
    },
    updateButtonTitle: {
      type: String,
      default: 'Update Cart'
    },
    updateButtonClasses: {
      type: [String, Array, Object],
      default: null
    }
  },

  mixins: [ValidationMixins],

  data() {
    return {
      fields: {
        termsAgreed: this.termsAgreed || 'no',
        productId: null,
        quantity: 1,
        product: null,
      },
      isAddingToCart: false,
      showPreview: false,

      validations: parseValidationSetup(validations, this),
    }
  },
  validations: {fields: parseValidations(validations)},

  created() {
    this.isAddingToCart = false
    EventBus.$emit('buy-card.create')

    if (this.editMode) {
      EventBus.$emit('buy-card.before.edit')
      this.fields = {
        termsAgreed: 'yes',
        productId: this.editModeData.payload.product_id,
        quantity: this.editModeData.count
      }
      EventBus.$emit('buy-card.edit', this.fields)
    }
  },
  watch: {
    showPreview() {
     this.lazyScrollTo('.re-page')
    },
    'fields.productId'(newVal) {
      EventBus.$emit('buy-card.change.productId', newVal)
    },
    'fields.quantity'(newVal) {
      EventBus.$emit('buy-card.change.quantity', newVal)
    },
  },

  computed: {
    cards() {
      return _.mapValues(this.cardsList || [], item => {
        item.$numbers = {
          price: _.toNumber(item.price),
          priceRound: _.round(item.price),
        }
        return item
      })
    },
    showPreviewCard() {
      return this.hasPreviewCard && this.showPreview
    },
    showAgreeToTermsBox() {
      return !this.noAgreeToTerms
    },
    disabledAmountBox() {
      return this.showAgreeToTermsBox && this.fields.termsAgreed !== 'yes'
    },
    disabledNextButton() {
      return this.disabledAmountBox || _.isNil(this.fields.productId) || !this.fields.quantity
    },
    amountSelectLabel() {
      return this.showFormLabels ? this.amountBoxLabel : null
    },
    quantityInputLabel() {
      return this.showFormLabels ? this.quantityLabel : null
    }
  },

  methods: {
    addCardToCart() {
      EventBus.$emit('buy-card.before.add-to-cart')
      this.fields.product = _.find(_.values(this.cards), c => {
        return (1 * c.id) === (1 * this.fields.productId)
      })
      this.isAddingToCart = true
      EventBus.$emit('buy-card.add-to-cart', this.fields)
    },

    addCardToCartAndGo() {
      this.addCardToCart()
      this.$router.push({ name: 'cart' })
    },
    openCardPreview() {
      this.showPreview = true
      EventBus.$emit('buy-card.preview.open')
    },
    hideCardPreview() {
      this.showPreview = false
      EventBus.$emit('buy-card.preview.back')
    },
  }
}
